export const globalStyles = {
  colors: {
    brand: {
      700: '#508C9B',
      800: '#002949',
      900: '#000028',
    },
    secondary: '#002949',
    outline: '#00cccc',
  },
}
